import { Form, Formik } from 'formik'
import { ListGroup, ListGroupItem } from 'reactstrap'
import { LoaderButton } from 'components/molecules'
import PropTypes from 'prop-types'
import ProductPerPageFilterField from 'domains/product/organisms/paging-filter-field/product-per-page-filter-field'
import MarketingDiscountBatchItemSkuField from './marketing-discount-batch-item-sku-field'
import MarketingDiscountBatchItemStatusField from './marketing-discount-batch-item-status-field'

const propTypes = {
  initialFilters        : PropTypes.object,
  handleSubmitForm      : PropTypes.func.isRequired,
  perPage               : PropTypes.string.isRequired,
  handlePerPageOnChange : PropTypes.func.isRequired
}

const defaultProps = {
  initialFilters        : { },
  handleSubmitForm      : () => { },
  perPage               : '10',
  handlePerPageOnChange : () => { }
}

const MarketingDiscountBatchItemFilterForm = ({
  initialFilters,
  handleSubmitForm,
  perPage,
  handlePerPageOnChange
}) => {
  const initialValues = {
    status   : initialFilters?.status || '',
    sku      : initialFilters?.sku || '',
    page     : initialFilters?.page || 1,
    per_page : initialFilters?.per_page || 10
  }

  return (
    <Formik
      initialValues={ initialValues }
      onSubmit={ handleSubmitForm }
      enableReinitialize={ true }
    >
      {
        (formik) => (
          <Form>
            <ListGroup>
              <ListGroupItem>
                <ProductPerPageFilterField
                  perPage={ perPage }
                  handlePerPageOnChange={ handlePerPageOnChange }
                />
              </ListGroupItem>

              <ListGroupItem>
                <MarketingDiscountBatchItemSkuField />
              </ListGroupItem>

              <ListGroupItem>
                <MarketingDiscountBatchItemStatusField />
              </ListGroupItem>

              <div className='d-flex justify-content-center position-sticky fixed-bottom bg-white py-3'>
                <LoaderButton
                  className='float-right'
                  color='primary'
                  type='submit'
                  disabled={ formik.isSubmitting }
                  isLoading={ formik.isSubmitting }
                  text={ 'SEARCH' }
                />
              </div>

            </ListGroup>
          </Form>
        )
      }

    </Formik>
  )
}

MarketingDiscountBatchItemFilterForm.propTypes    = propTypes
MarketingDiscountBatchItemFilterForm.defaultProps = defaultProps

export default MarketingDiscountBatchItemFilterForm
